import React from "react";

import { ModuleWrapperV2 } from "../../components/moduleWrapper/moduleWrapper.v2";
import type { SeparatorProps } from "./separator.types";

export default class Separator extends React.Component<SeparatorProps> {
  name = this.props.data.item.name;
  paddings = { top: this.props.data.item.padding_top, bottom: this.props.data.item.padding_bottom }
  separator_color = this.props.data.item.separator_color?.value;
  background_color = this.props.data.item.background_color?.value;

  render() {
    return <ModuleWrapperV2
      name={this.name}
      paddings={this.paddings}
      backgroundColor={this.background_color}
      backgroundImage={undefined}
      anchor={undefined}
    >
      <div className="max-w-7xl mx-auto">
        <div className="w-full h-[1px]" style={{ backgroundColor: this.separator_color }} />
      </div>
    </ModuleWrapperV2>
  }
}